import { ArrowRight, MapPin, Map } from "lucide-react";

const MAP_3D_URL = "https://realsanjose.mapioland.com/map/";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/20858785/pexels-photo-20858785.jpeg)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/70" />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] w-full mx-auto px-6 md:px-12 lg:px-16 pb-20 md:pb-32 pt-28 md:pt-32">
        <div className="max-w-3xl">
          <div className="fade-in-up flex items-center gap-3 mb-3 text-white/90">
            <span className="h-px w-10 bg-[#C9B68A]" />
            <span className="text-xs tracking-[0.3em] uppercase font-medium">
              Real San José Residencial · por Lauburu
            </span>
          </div>

          <img
            src="https://customer-assets.emergentagent.com/job_land-marketplace-27/artifacts/dsh5mmu4_Ima%CC%81genes%20Meli%20Walmart%20Elektra%20-%20Easyliving%20-%20Nuevo%20Disen%CC%83o%20-%20Alex.png"
            alt="Real San José Residencial"
            className="fade-in-up block mx-auto h-36 sm:h-44 lg:h-52 w-auto object-contain mb-2"
            style={{ filter: "brightness(0) invert(1)" }}
            data-testid="hero-rsj-logo"
          />

          <h1 className="fade-in-up fade-delay-1 font-heading text-white text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[1.02] text-balance">
            El espacio perfecto
            <br />
            para tu hogar.
          </h1>

          <p className="fade-in-up fade-delay-2 mt-4 sm:mt-5 text-white/85 text-lg sm:text-xl max-w-xl leading-relaxed font-light">
            Lotes residenciales en <strong className="font-medium text-white">Real San José</strong>,
            el nuevo fraccionamiento desarrollado por Lauburu. Listos para
            construir, con red eléctrica, drenaje y calles de concreto.
          </p>

          <div className="fade-in-up fade-delay-3 mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#69573B] hover:bg-[#2D2920] text-white text-sm font-medium tracking-[0.18em] uppercase rounded-md transition-all"
            >
              Agendar Visita
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </a>
            <a
              href={MAP_3D_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-map3d"
              className="group inline-flex items-center justify-center gap-3 px-8 py-4 border border-white/40 hover:border-white hover:bg-white/10 text-white text-sm font-medium tracking-[0.18em] uppercase rounded-md backdrop-blur-sm transition-all"
            >
              <Map size={16} />
              Ver mapa 3D
            </a>
          </div>

          {/* Stats / quick info */}
          <div className="fade-in-up fade-delay-3 mt-12 grid grid-cols-2 gap-8 max-w-2xl border-t border-white/20 pt-6">
            <div>
              <div className="font-heading text-3xl sm:text-4xl font-light text-white">100%</div>
              <div className="text-xs tracking-[0.2em] uppercase text-white/70 mt-2">Urbanizado</div>
            </div>
            <div>
              <div className="font-heading text-3xl sm:text-4xl font-light text-white flex items-center gap-2">
                <MapPin size={26} className="text-[#C9B68A]" /> Listo
              </div>
              <div className="text-xs tracking-[0.2em] uppercase text-white/70 mt-2">Para construir</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
